import styled from "styled-components";

export const CustomButton = styled.button`
    border: 0;
    background-color: transparent;
    transform-origin: top center;

    &:hover { 
        animation: shake 0.9s ease-in-out;
        animation-iteration-count: 0.6;
    }

    @keyframes shake {
        0% { transform: rotate(0deg); }
        10% { transform: rotate(-5deg); }
        20% { transform: rotate(0deg); }
        30% { transform: rotate(5deg); }
        40% { transform: rotate(0deg); }
        50% { transform: rotate(-5deg); }
        60% { transform: rotate(0deg); }
        70% { transform: rotate(5deg); }
        80% { transform: rotate(0deg); }
        90% { transform: rotate(-5deg); }
        100% { transform: rotate(0deg); }
    }
`;